var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBasicAvatarSkeleton = function SvgBasicAvatarSkeleton(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM4.28 13.2C5.328 12.448 6.608 12 8 12C9.392 12 10.672 12.448 11.72 13.2C10.672 13.952 9.392 14.4 8 14.4C6.608 14.4 5.328 13.952 4.28 13.2ZM12.912 12.096C11.56 11.04 9.856 10.4 8 10.4C6.144 10.4 4.44 11.04 3.088 12.096C2.16 10.984 1.6 9.56 1.6 8C1.6 4.464 4.464 1.6 8 1.6C11.536 1.6 14.4 4.464 14.4 8C14.4 9.56 13.84 10.984 12.912 12.096Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.2C6.456 3.2 5.2 4.456 5.2 6C5.2 7.544 6.456 8.8 8 8.8C9.544 8.8 10.8 7.544 10.8 6C10.8 4.456 9.544 3.2 8 3.2ZM8 7.2C7.336 7.2 6.8 6.664 6.8 6C6.8 5.336 7.336 4.8 8 4.8C8.664 4.8 9.2 5.336 9.2 6C9.2 6.664 8.664 7.2 8 7.2Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBasicAvatarSkeleton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "basic-avatar-skeleton.1d4c5101fc7421f36e7799a6ba3b4c9f.svg";